import {
    GET_LEAD_PROFILE_REQUEST,
    GET_LEAD_PROFILE_REQUEST_SUCCESS,
    GET_LEAD_PROFILE_REQUEST_FAILURE,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS,
    GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE,
} from '../constants/get_lead_profile.constants';


export const getLeadProfileRequest = (_id) => ({ type: GET_LEAD_PROFILE_REQUEST, _id });
export const getLeadProfileRequestSuccess = (payload, key) => ({ type: GET_LEAD_PROFILE_REQUEST_SUCCESS, payload, key });
export const getLeadProfileRequestFailure = (error) => ({ type: GET_LEAD_PROFILE_REQUEST_FAILURE, error });
export const getLeadProfileWithNotesRequest = (_id) => ({ type: GET_LEADS_PROFILE_WITH_NOTES_REQUEST, _id });

export const getLeadProfileWithNotesRequestSuccess = (payload) => ({
    type: GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS,
    payload,
});
export const getLeadProfileWithNotesRequestFailure = (error) => ({
    type: GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_lead_profile.actions.js